<button class="view-order-container">
  <cwo-icon role="img" class="icon" [name]="iconNameType.grocery" [attr.alt]="'Cart'"/>
  <span class="sr-only">{{'View order'}}</span>
  @if(itemCount() > 0){
  <div class="counter-container" [ngClass]="{overflow: itemCount() > 99}">
    <span class="counter" [ngClass]="{overflow: itemCount() > 99}">{{itemCount() > 99 ? '99' : itemCount()}}</span>
  </div>
  }
</button>